import React from "react";
import FontAwesome from "react-fontawesome";

import Sunset from "../components/Sunset";

import "../styles/Music.css";

const Music = () => (
    <div>
        <Sunset />
        <div className="music-container">
            <div className="mt-5 mb-5 d-flex row justify-content-center">
                <div className="mt-5">
                    <h3 className="album-title">
                        Keep On Movin' - 2015
                        <span>
                            <a href="https://www.amazon.com/Keep-Movin-Jeremy-Jones/dp/B00SIJC3OG">
                                <FontAwesome
                                    className="shopping-cart"
                                    name="shopping-cart"
                                />
                            </a>
                        </span>
                    </h3>
                    <iframe
                        src="https://open.spotify.com/embed?uri=spotify:album:4xWbt32pesTOklFx3Jr9Yc?si=zF4Fjf49TXm3Fh-kuR_8Ow"
                        allow="encrypted-media"
                        className="album"
                        title="Keep On Movin' album"
                    />
                </div>

                <div className="mt-5">
                    <div className="album-title">
                        From Here On - 2010
                        <span>
                            <a href="https://www.amazon.com/Here-Jeremy-Jones/dp/B0039BD9HI">
                                <FontAwesome
                                    className="shopping-cart"
                                    name="shopping-cart"
                                />
                            </a>
                        </span>
                    </div>
                    <iframe
                        src="https://open.spotify.com/embed?uri=spotify:album:0W8vGFx7Wjd4Z8UIOcj7UV?si=j4KXkt_sQKGAcBLMNtuI7A"
                        allow="encrypted-media"
                        className="album"
                        title="From Here On album"
                    />
                </div>
            </div>
        </div>
    </div>
);

export default Music;



// WEBPACK FOOTER //
// ./src/components/Music.js